import prayStudioLogo from 'images/pray-studio-logo.svg';

const StudioLogo = () => <img src={prayStudioLogo} alt="Pray Studio" className="aspect-[138/18]" />;

export default StudioLogo;
